import styled from 'styled-components';
import { colors, breakpoints } from 'app/variables';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  input {
    font-size: 16px;
    padding-left: 0.1rem !important;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    border-radius: 0 !important;
  }
  input[type='number'] {
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
    }
  }
  textarea {
    font-size: 1rem;
    text-align: center;
    &::placeholder {
      text-align: left;
    }
  }
  & textarea:focus::placeholder {
    color: transparent;
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding-bottom: 0;
  }

  &:focus-visible {
    outline: none;
  }
`;
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding 0 1rem;

`;
export const NotAvailableMessage = styled.div`
  color: ${colors.emperor};
  font-weight: bold;
  line-height: 26px;
  font-size: 20px;
  text-align: center;
  padding: 4rem 0;
`;
export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-image: radial-gradient(
    circle at 4px 50%,
    transparent 60%,
    ${colors.alto} 50%
  );
  background-size: 11px 1px;
  background-repeat: repeat-x;
`;
